
export const serverAppConfig = {
  "storeId": "62b45c78052ce4126af4112c",
  "categories": [
    {
      "id": "62b487f3dbab431cbe6fc330",
      "name": "Hällar",
      "slug": "hallar",
      "description": "I vårt breda sortiment av hällar hittar du både gashällar och induktionshällar. Välj mellan flera modeller, storlekar och varianter för att hitta den perfekta hällen för ditt kök. Våra hällar passar i såväl moderna som mer klassiska kök!",
      "thumbnailDescription": "",
      "additionalText": "<h2>En spishäll för varje kök</h2>\n<p>En spishäll kommer med flexibilitet och ger dig möjlighet att placera den på en yta som passar dig, och inte nödvändigtvis i samband med en spis. För dig som tycker om att ta ut svängarna i köket och vill ha en spishäll som tar din matlagning till nästa nivå, bör du ta en titt på våra gashällar och induktionshällar.</p>\n<h2>Våra spishällar</h2>\n<p>Här kan du köpa spishällar online på ett smidigt och säkert sätt. Vi har ett stort utbud av riktigt bra hällar för proffset såväl som för amatörkocken. I sortimentet hittar du produkter från varumärken såsom Ilve, SMEG och Bertazzoni. </p>\n<h3>Gashällar</h3>\n<p>En <a href=\"https://www.gasspisen.se/categories/hallar-gashallar\">gashäll</a>, känd för sin förmåga att erbjuda omedelbar värme och exakt temperaturkontroll, är ett populärt val bland professionella kockar, såväl som hemmakockar. Designen varierar från enklare modeller med några brännare till avancerade versioner med flera brännare och extrafunktioner som wokbrännare. Gashällar är också uppskattade för sin hållbarhet och enkla rengöring.</p>\n<h3>Induktionshällar</h3>\n<p><a href=\"https://www.gasspisen.se/categories/hallar-induktionshallar\">Spishällar med induktion</a> är en modern typ av spishäll som är mer energieffektiv och snabbare än traditionella elektriska hällar. Med elektromagnetiska fält värmer induktionshällen upp kastruller och stekpannor direkt, istället för att värma upp själva hällen. Induktionshällen har även en hög grad av temperaturkontroll, vilket gör den idealisk för noggranna matlagningsmetoder. Dessutom blir ytan på hällan inte lika varm som andra hällar, vilket ökar säkerheten i köket.</p>\n<h3>Gas- och induktionshällar</h3>\n<p>En <a href=\"https://www.gasspisen.se/categories/hallar-gas-induktion\">spishäll med gas och induktion</a> erbjuder det bästa av två världar när det gäller matlagning. Den kombinerar den snabba och exakta värmejusteringen hos gasbrännare med den energieffektiva och jämna värmen från induktionstekniken. Detta gör den idealisk för kockar som vill ha flexibilitet och kontroll över sin matlagning, eftersom de kan använda olika metoder för olika rätter. </p>",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/varagashallar.webp",
      "thumbnailUrl": "",
      "order": 3,
      "metaTitle": "Hällar - Spishällar i ett stort sortiment",
      "metaDescription": "Vi erbjuder ett brett sortiment av hällar - allt från spishällar till hällar med induktion och gas. Se utbudet och beställ med fri frakt här!",
      "metaHeader": "Spishällar",
      "subCategories": [
        {
          "id": "62b487fddbab431cbe6fc331",
          "name": "För stadsgas",
          "slug": "hallar-for-stadsgas",
          "description": "Nedan hittar du våra spishällar för stadsgas. Vi har ett stort utbud med många varianter på våra spishällar. Vi har produkter för såväl Stockholms stadsgas som Göteborgs stadsgas och Malmös stadsgas. Du hittar bland annat spishällar från välkända varumärken som SMEG och Bertazzoni. Ta en titt i vårt sortiment nedan!",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/hallar-stadsgas.webp",
          "thumbnailUrl": "",
          "order": 5,
          "metaTitle": "För stadsgas - Spishäll",
          "metaDescription": "Se vårt sortiment av spishällar för stadsgas. Vi har flera modeller och mängder av varianter från ledande varumärken. Se utbudet här!",
          "metaHeader": "Spishällar för stadsgas",
          "subCategories": null
        },
        {
          "id": "62b4880ddbab431cbe6fc333",
          "name": "Gas & Induktion",
          "slug": "hallar-gas-induktion",
          "description": "Söker du en spishäll med gas- och induktion? Då har du hittat helt rätt. I vårt sortiment hittar du kombinerade gas- och induktionshällar som kombinerar en fristående gashäll med en spishäll med induktion, så att du får det bästa av båda världar. Hitta en kombinerad gas- och induktionshäll som fyller dina behov i sortimentet nedan.",
          "thumbnailDescription": "",
          "additionalText": "<h2>Gas & induktion i kombination för större frihet</h2>\n<p>Vill du få ut så mycket som möjligt av ditt kök och skapa större frihet i din matlagning? Med gas och induktion i kombination kan du skapa magi med råvaror! Komplettera den med ett stekbord eller en grillplatta och ta dina insatser i köket till en helt ny nivå. Laga mat som proffsen och dra nytta av fördelarna som kommer med både gas och induktion – i kombination maximerar de dina möjligheter.</p><br>\n<h3>Stort utbud med flera varianter</h3>\n<p>I vårt breda sortiment hittar du flera varianter från kända varumärken. Kolla igenom sortimentet ovan och hitta en kombinerad gas- och induktionshäll som passar dig och dina matlagningsbehov. I vårt sortiment hittar du även <u><a href=\"https://www.gasspisen.se/categories/hallar-induktionshallar\">spishäll med induktion</a></u> enbart, i flera varianter och från flera kända varumärken!</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/PM3743D_2.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/PM3743D_2.jpg",
          "order": 3,
          "metaTitle": "Spishäll - Gas & induktion",
          "metaDescription": "Spishäll med gas och induktion i kombination. I vårt breda utbud finns kombinerade gas- och induktionshällar för större frihet i köket. Fri frakt här!",
          "metaHeader": "Kombinerad gas- och induktionshäll",
          "subCategories": null
        },
        {
          "id": "62b48813dbab431cbe6fc334",
          "name": "Gashällar",
          "slug": "hallar-gashallar",
          "description": "Gashäll i stort utbud hos Stenlundsgruppen. Här har vi samlat våra olika varianter och modeller i olika prisklasser, passande för alla typer av kök och matlagningsbehov. Med fokus på kvalitet och användarvänlighet är gashällarna i vårt sortiment ett utmärkt val för dig som söker en hållbar och effektiv lösning!",
          "thumbnailDescription": "",
          "additionalText": "<h2>Våra gashällar</h2>\n<p>Hos oss kan du köpa gashällar i flera olika varianter och modeller som är designade för att möta varierande matlagningsstilar och preferenser. Välj mellan olika storlekar för att hitta en gashäll som passar ditt kök, vi har något för stora och små kök med gashällar som är allt från 30 cm till 100 cm och i flera olika färger. I sortimentet hittar du även såväl en gashäll med 2 brännare som hällar med 4, 5 eller 6 brännare.</p></br>\n\n<p>Vi har en gashäll som passar varje kök och stil!</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/gashallar-banner.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/Gasha%CC%88llar.webp",
          "order": 1,
          "metaTitle": "Gashäll - Gashällar från Gasspisen.se",
          "metaDescription": "Gashäll i stort utbud hos Stenlundsgruppen. Här har vi samlat våra olika varianter och modeller i olika prisklasser. Beställ i dag med fri frakt!",
          "metaHeader": "",
          "subCategories": [
            {
              "id": "6ab3825c55b28e678cafde5e",
              "name": "30cm",
              "slug": "hallar-gashallar-30cm",
              "description": "En kompakt gashäll på 30 cm passar för det mindre köket eller som komplement till en befintlig häll. Hos oss hittar du högkvalitativa modeller med en brännare eller två brännare över en samlad kokzon, från välkända tillverkare som Smeg och Ilve. Bläddra bland vårt utbud för att hitta en gashäll på 30 cm som passar dig.",
              "thumbnailDescription": "Gashällar 30 cm",
              "additionalText": "<h2>Material av hög kvalitet</h2>\n\nHos oss kan du köpa en liten gashäll på 30–38 cm i elegant svart glas eller i klassiskt rostfritt stål. De levereras med rejäla gjutjärnsgaller som ger stabil avlastning för dina kastruller. Samtliga modeller i denna kategori är utrustade med elektronisk tändning för en enkel start, samt en säkerhetsventil som automatiskt stänger av gastillförseln om lågan skulle slockna.",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/MFBG901ZW2_Img_ImgPrdPho_DetailShot_Pandrager.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/MFBG901ZW2_Img_ImgPrdPho_DetailShot_Pandrager.png",
              "order": 1,
              "metaTitle": "Gashäll 30 cm - Gasspisen.se",
              "metaDescription": "Stort utbud av gashäll 30 cm. Välj mellan 1-2 brännare och utföranden i olika färger, material och stilar. Beställ liten gashäll här!",
              "metaHeader": "Gashällar 30 cm",
              "subCategories": null
            },
            {
              "id": "6ab5017cda5b255d37d62153",
              "name": "60cm",
              "slug": "hallar-gashallar-60cm",
              "description": "En gashäll på 60 cm är standardmåttet för de flesta svenska kök och ett bra val för dig som vill ha professionell matlagning på en kompakt yta. Våra modeller från bland annat Bertazzoni och Smeg finns i olika utföranden, från en mjukare klassisk estetik till en slät, modern och minimalistisk stil. Med 3 eller 4 brännare får du flexibilitet nog att hantera både stora gjutjärnsgrytor och mindre kastruller samtidigt.",
              "thumbnailDescription": null,
              "additionalText": "<h2>Detaljer i mässing, emalj och gjutjärn</h2>\n\n<p>Våra 60 cm gashällar är byggda av hållbara material som håller i generationer. Välj mellan hällar i elegant rostfritt stål eller lackerat stål i klassiska nyanser som creme och svart. De noggrant utformade detaljerna sätter stilen i köket, där du kan välja mellan stilrena vred i solid metall, mässing eller tidlös emalj.</p>\n\n<p>Hällarna är utrustade med rejäla gjutjärnsgaller som ger en jämn värmespridning och ett stabilt underlag för tunga kokkärl och stekpannor. Med elektronisk tändning och inbyggda säkerhetsventiler kan du känna dig trygg, då de omedelbart stryper gastillförseln om lågan oväntat skulle blåsas ut, till exempel om en kastrull kokar över och släcker den.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_334220522_L.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_334220522_L.jpg",
              "order": 2,
              "metaTitle": "Gashäll 60 cm - Gasspisen.se",
              "metaDescription": "Köp gashäll på 60 cm med 3 eller 4 brännare från märken som Smeg och Bertazzoni. Välj mellan moderna eller klassiska utföranden med snygga detaljer.",
              "metaHeader": "Gashäll 60 cm",
              "subCategories": null
            },
            {
              "id": "6ab5018bda5b255d37d62154",
              "name": "70cm",
              "slug": "hallar-gashallar-70cm",
              "description": "En gashäll på 70 cm har fem brännare och rymmer flera stora kokkärl samtidigt utan att kastrullerna trängs på ytan. Vi erbjuder premiummodeller från bland annat Smeg och Ilve, anpassade för naturgas, gasol och stadsgas. Välj bland tidlösa utföranden i vitt och creme eller moderna varianter i svart eller rostfritt stål. Med fem brännare ryms flera stora kokkärl samtidigt utan att kastrullerna trängs på ytan.",
              "thumbnailDescription": null,
              "additionalText": "<h2>Hög kvalitet och säkerhet</h2>\n\nMed en gashäll på 70 cm får du en tålig arbetsyta av hög kvalitet i rostfritt stål eller emalj och stabila gjutjärnsgaller. Gallren kan fås i form av kryss för varje brännare eller plattor som täcker flera brännare. Vi har även gashällar på 75 cm i sortimentet. Hällarna har exakt värmereglering, och du kan välja mellan flera olika tillagningsfunktioner. Modellerna är utrustade med elektrisk tändning och en mekanisk termosäkring som automatiskt stänger gastillförseln om en låga slocknar.",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/97922bc9-b628-4e86-8ae9-cb8f4e1db24a.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/97922bc9-b628-4e86-8ae9-cb8f4e1db24a.jpg",
              "order": 3,
              "metaTitle": "Gashäll 70 cm - Gasspisen.se",
              "metaDescription": "Köp gashäll 70 cm med 5 brännare från premiumvarumärken hos oss. Tidlös design och kvalitet.",
              "metaHeader": "Gashäll 70 cm",
              "subCategories": null
            },
            {
              "id": "6ab501a0da5b255d37d62155",
              "name": "80cm",
              "slug": "hallar-gashallar-80cm",
              "description": "En gashäll på 80 cm har 5 eller 6 brännare och kan ge mer avställningsyta än smalare modeller, beroende på brännarnas placering och hällens layout. Hos oss hittar du premiummodeller i klassiskt utförande från bland annat Smeg, med rostfritt stål och gjutjärnsgaller. Många modeller är även utrustade med en extra snabb brännare för snabbare uppkokning.",
              "thumbnailDescription": null,
              "additionalText": "<h2>Rymliga hällar av hög kvalitet</h2>\n\nStorleken skapar gott om utrymme för flera kastruller och grytor bredvid varandra på spishällen. När du köper en gashäll på 80 cm kan du välja mellan stabila gjutjärnsgaller i form av kryss eller plattor, som ger trygg avlastning åt tunga kokkärl under tillagningen. Modellerna har elektrisk tändning och är utrustade med termosäkring eller flamvakt som automatiskt stänger av gasflödet om en låga skulle slockna. Tänk på att gasanslutning och munstycken varierar, men de flesta modellerna levereras med dysor för naturgas, gasol och stadsgas.",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_588474290_XL.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_588474290_XL.jpg",
              "order": 4,
              "metaTitle": "Gashäll 80 cm - Gasspisen.se",
              "metaDescription": "Köp gashäll 80 cm från Smeg och andra premiumvarumärken, med en rymlig arbetsyta och 5 eller 6 brännare.",
              "metaHeader": "Gashäll 80 cm",
              "subCategories": null
            },
            {
              "id": "6ab501a8da5b255d37d62156",
              "name": "90cm",
              "slug": "hallar-gashallar-90cm",
              "description": "En gashäll på 90 cm ger gott om avstånd mellan kokzonerna så att breda stekpannor och grytor ryms sida vid sida. I vårt sortiment finns hällar med 5 eller 6 brännare samt varianter med ett praktiskt stekbord i rostfritt stål, perfekt för smash burgers. Välj bland välkända tillverkare som Smeg, Ilve, Eico och Bertazzoni, med hällar i klassiska eller moderna utföranden i svart, vitt, creme och rostfritt.",
              "thumbnailDescription": null,
              "additionalText": "<h2>Slitstarka material och flexibla brännare</h2>\n\nVåra gashällar på 90 cm i rostfritt stål hanterar vardagens slitage väl och kan enkelt torkas rent efter matlagningen, medan gallren smidigt kan avlägsnas vid rengöring runtom brännarkopparna. De sektionsdelade gjutjärnsgallrena är ett stadigt stöd för tunga grytor så att du slipper oroa dig för att välta ut något. Om du väljer en Smeg gashäll på 90 cm får du ofta en extra snabb brännare för snabbare uppkokning, medan andra modeller har dubbla wokbrännare för intensiv stekning. Hällarna kan anpassas för gasol eller naturgas, och vid efterfrågan kan vi även skicka med dysor för stadsgas.",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/PV395LCN_2.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/PV395LCN_2.jpg",
              "order": 5,
              "metaTitle": "Gashäll 90 cm - Gasspisen.se",
              "metaDescription": "Köp gashäll 90 cm med 5-6 brännare eller stekbord i rostfritt stål. Välj bland klassiskt eller modernt utförande.",
              "metaHeader": "Gashäll 90 cm",
              "subCategories": null
            }
          ]
        },
        {
          "id": "62b48820dbab431cbe6fc336",
          "name": "Induktionshällar",
          "slug": "hallar-induktionshallar",
          "description": "Välj en modern spishäll med induktion från Gasspisen.se. Vi har ett stort utbud av induktionshällar från flera kända varumärken och i flera olika varianter. Med hjälp av induktion går matlagningen mycket fortare och du kan jobba effektivare, eftersom kärlet värms upp direkt. Se vårt utbud av spishällar med induktion nedan!",
          "thumbnailDescription": "",
          "additionalText": "<h2>Induktionshällar för alla kök</h2>\n<p>En induktionshäll är ett vanligt val i moderna kök – inte minst för att en spishäll med induktion har en effektiv uppvärmning, men också för att det är lätt att rengöra och att plattornas temperatur går att kontrollera med enkelhet. Här på Gasspisen.se hittar du ett stort sortiment av induktionshällar av högsta kvalitet. Välj mellan flera storlekar och varianter från flera kända varumärken. I vårt sortiment finns också <u><a href=\"https://www.gasspisen.se/categories/hallar-gas-induktion\">spishäll med gas och induktion</a></u> i kombination. Tveka inte på att kontakta oss för mer information om en produkt eller hjälp med din beställning av häll med induktion.</p></br>\n<h3>En induktionshäll kommer med många fördelar</h3>\n<p>En induktionshäll kommer med så många fördelar som inte går att finna hos en traditionell spishäll. Induktion tillåter dig att snabbt nå rätt temperatur och du kan koka upp vatten på nolltid. Tack vare att det är induktionen som värmer upp dina kastruller och grytjärn, och inte själva plattan, är en induktionshäll extra lätt att hålla ren, precis som en induktionsspis. Upptäck fördelarna med en induktionshäll och ta en titt i vårt sortiment nedan. Om du har några frågor är du välkommen att kontakta oss.</p></br>\n<h3>Spishäll: induktion ger säkrare matlagning</h3>\n<p>Att laga mat på en induktionshäll är säkrare än på andra typer av spishäll. Induktion bryts när du tar av dina kärl från plattan, vilket innebär att din induktionshäll inte heller varm efteråt. I vårt sortiment av spishällar hittar du även gashäll, grillhäll och stekhäll.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/banner-induktion.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/Induktionsha%CC%88llar.webp",
          "order": 2,
          "metaTitle": "Spishäll - Induktion",
          "metaDescription": "Stort sortiment av spishällar med induktion. Välj mellan våra induktionshällar i olika modeller och från flera kända märken. Fri frakt här!",
          "metaHeader": "",
          "subCategories": null
        },
        {
          "id": "62b48826dbab431cbe6fc337",
          "name": "Stekhäll",
          "slug": "hallar-stekhall",
          "description": "Beställ en stekhäll, stekbord eller en stekplatta online via Gasspisen.se. Vi har ett stort sortiment av stekhällar och stekbord för både gashäll och induktionshäll i flera varianter och storlekar för nybörjare såväl som för proffs. Kolla in vårt sortiment av stekhäll och stekplatta nedan och gör matlagningen till ett ännu större nöje!",
          "thumbnailDescription": "",
          "additionalText": "<h2>Så väljer du rätt storlek på stekhällar</h2>\n<p>Hos oss hittar du ett brett utbud av stekhällar i flera storlekar och varianter. Välj den storlek som passar ditt ändamål. Tumregeln för vilken storlek du ska välja på ditt stekbord brukar vara: • 45–50 cm: 2–4 personer • 55–60 cm: 6–8 personer • 70+ cm: större sällskap.</p>\n<h2>Enklare matlagning med stekbord</h2>\n<p>Med ett stekbord blir det enklare, och framför allt roligare, att laga mat. Tillaga måltider med samma finess som de gör på restaurang med ett stekbord hemma. Stek, koka eller woka och ta ut svängarna ordentligt med ett stekbord. Induktion eller gas, vi har stekhällar och stekplattor som funkar för båda sorters spishäll.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/stekhall-banner.webp",
          "thumbnailUrl": "",
          "order": 4,
          "metaTitle": "Stekhäll / stekbord / stekplatta | Stort utbud här",
          "metaDescription": "Välkommen till vårt stora sortiment av stekhällar, stekbord och stekplattor för hemmakockar och proffs. Se vårt utbud och handla online. →",
          "metaHeader": "Stekhäll / Stekbord / Stekplatta",
          "subCategories": null
        }
      ]
    },
    {
      "id": "62b4882edbab431cbe6fc338",
      "name": "Ugnar",
      "slug": "ugnar",
      "description": "Inbyggnadsugnar erbjuder en snygg och integrerad lösning för ditt kök, vilket optimerar utrymmet och ger ett enhetligt utseende. Med en mängd olika funktioner och designalternativ kan du hitta en modell som passar dina matlagningsbehov. Vi erbjuder ett stort sortiment av integrerade ugnar i flera storlekar, varianter och från flera välkända varumärken. Vi erbjuder alltid fri frakt på våra inbyggnadsugnar.",
      "thumbnailDescription": "",
      "additionalText": "<h2>En ugn för inbyggnad ger ditt kök ett modernt uttryck</h2>\nEn ugn för inbyggnad ger köket ett modernt och stilrent uttryck. Designa ditt drömkök med en inbyggnadsugn från oss på Gasspisen.se. Jämför våra modeller i olika höjd och bredd för att hitta den som passar in i just ditt kök. Vi säljer enbart ugnar från erkända varumärken av högsta kvalitet.\n\n<h2>Välj en integrerad ugn för en smidigare vardag</h2>\nFå en smidigare vardag och ta matlagningsglädjen en nivå högre med en integrerad ugn. Placera den var du vill i höjdled för att den ska passa just dig, ditt kök och dina behov. Med en ugn som är integrerad behöver du inte heller tänka på att den ska placeras i anslutning till din köksfläkt eller induktionshäll - en integrerad ugn ger dig både flexibilitet och möjlighet att ta ut svängarna i köket.",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/brx_postcardDeskLarge (2).jpg",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/brx_postcardDeskLarge (2).jpg",
      "order": 4,
      "metaTitle": "Våra inbyggnadsugnar",
      "metaDescription": "Gasspisen.se erbjuder ett brett sortiment av inbyggnadsugnar. Välj mellan flera modeller och storlekar. Beställ en integrerad ugn från oss i dag!",
      "metaHeader": "Ugnar",
      "subCategories": [
        {
          "id": "62b48837dbab431cbe6fc339",
          "name": "Mikrovågsugnar",
          "slug": "ugnar-mikrovagsugnar",
          "description": "En inbyggd mikrovågsugn ger ditt kök ett modernt och stilrent utseende samtidigt som du sparar bänkyta i köket som en mikrovågsugn annars brukar ta upp. Här på Gasspisen.se hittar du ett stort sortiment av inbyggda mikrovågsugnar i flera varianter, modeller och färger. Se vårt utbud nedan och hitta din favorit! Hos oss handlar du alltid en integrerad mikrovågsugn med fri frakt!",
          "thumbnailDescription": "",
          "additionalText": "<h2>En inbyggd mikrovågsugn ger köket ett modernt utseende</h2>\n<p>De flesta moderna kök har idag en inbyggd mikrovågsugn, då den ger köket ett modernt och stilrent utseende. Vi har inbyggda mikrovågsugnar från flera kända varumärken som exempelvis SMEG, ILVE och Bertazzoni. Oavsett vad för modell du letar efter är vi övertygade om att du kan hitta någon som faller dig i smaken här i vårt sortiment.</p>",
          "imgUrl": "",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/Mikrova%CC%8Agsugnar.webp",
          "order": 2,
          "metaTitle": "Inbyggd mikrovågsugn - Beställ här med fri frakt",
          "metaDescription": "Vi har ett stort sortiment av inbyggda mikrovågsugnar. Handla en inbyggd mikrovågsugn online via Gasspisen.se idag. Alltid ✓Fri frakt!",
          "metaHeader": "Inbyggd mikrovågsugn",
          "subCategories": null
        },
        {
          "id": "62b4883edbab431cbe6fc33a",
          "name": "Ugnar",
          "slug": "ugnar-ugnar",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/Hero%20-%20ugnar.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/Ugnar.webp",
          "order": 1,
          "metaTitle": "Ugn - Köp ugnar med fri frakt",
          "metaDescription": "Gasspisen.se har ett stort sortiment av ugnar. Se vårt utbud och beställ en ugn hos oss idag med ✓Fri frakt!",
          "metaHeader": "Inbyggnadsugn",
          "subCategories": null
        },
        {
          "id": "62b48846dbab431cbe6fc33b",
          "name": "Vakuumförpackare",
          "slug": "ugnar-vakuumforpackare",
          "description": "Vakuumförpacka kött och livsmedel enkelt i en vakuumförpackare från oss på Gasspisen.se. Hos oss hittar du ett stort sortiment av bra vakuumförpackare i flera modeller och varianter. Välj exempelvis mellan svarta och rostfria varianter från flera ledande varumärken. Se sortimentet nedan och hitta din favorit!",
          "thumbnailDescription": "",
          "additionalText": "<h2>Inbyggd vakuumförpackare, ett smidigt val</h2>\n<p>Hos oss hittar du en inbyggd vakuumförpackare som är ett mycket bra val, då den blir lättillgänglig och dessutom smälter in i köket på ett läckert sätt. I vårt sortiment hittar du riktigt bra vakuumförpackare från flera erkända varumärken, som exempelvis SMEG och ILVE. Välkommen till Gasspisen.se för att köpa vakuumförpackare som är inbyggd och av bästa kvalitet!</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/vakumfo_rpackare.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/vakumfo_rpackare.webp",
          "order": 3,
          "metaTitle": "Vakuumförpackare - Köp bra vakuumförpackare online",
          "metaDescription": "Här finns ett stort utbud av bra vakuumförpackare från flera ledande märken som SMEG och ILVE. Se vårt utbud och beställ en inbyggd vakuumförpackare här!",
          "metaHeader": "Vakuumförpackare",
          "subCategories": null
        }
      ]
    },
    {
      "id": "62b4885edbab431cbe6fc33e",
      "name": "Kyl & Frysskåp",
      "slug": "kyl-frysskap",
      "description": "Ett kombinerat kyl- och frysskåp är den perfekta lösningen för dig som har ont om plats eller vill ha en smidig lösning till köket. Gasspisen.se har ett stort sortiment av kombinerade kyl/frysskåp mellan 60 cm (standardmått) och 80 cm, från utvalda premiumvarumärken som SMEG, Bertazzoni, Ilve och Lofra. ",
      "thumbnailDescription": "",
      "additionalText": "<h2>Stort utbud för alla sorts kök</h2>\n<p>Hos oss kan du köpa kyl och frys i olika storlekar och välja bland moderna, stilrena och klassiska utföranden. Vi har allt från diskreta integrerade modeller till fristående varianter i ikoniska färger som krämvitt, rött, rosa eller ljusblått. Många av skåpen har underhållsfria och smarta egenskaper som automatisk avfrostning och inbyggd dispenser för is. I vårt sortiment finns även <a href=\"https://www.gasspisen.se/categories/kyl-frysskap-side-by-side\">side by side kyl- och frys</a> samt separata kyl- och frysskåp.</p>",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/kylar-frysar.webp",
      "thumbnailUrl": "",
      "order": 5,
      "metaTitle": "Kyl- och frysskåp från premiumvarumärken",
      "metaDescription": "Köp kyl- och frys hos oss. Vi erbjuder ett högkvalitativt sortiment från varumärken som Smeg & Bertazzoni. Välj mellan 60–80 cm, integrerat eller fristående.",
      "metaHeader": "Kyl- och frysskåp",
      "subCategories": [
        {
          "id": "62b48864dbab431cbe6fc33f",
          "name": "Side by side",
          "slug": "kyl-frysskap-side-by-side",
          "description": "Letar du efter en modern side-by-side kyl/frys? Då kan våra kylskåp och frysar med dubbeldörrar vara precis vad du letar efter. Här hittar du vårt utbud av side-by-side kyl/frys från exempelvis välkända märken som Bertazzoni. Ta en titt i vårt sortiment för att se om du kan hitta din favorit och missa inte heller våra populära kyl- och frysskåp.",
          "thumbnailDescription": "",
          "additionalText": "<h2>En praktisk och stilren lösning köket</h2>\n<p>En kyl och frys side-by-side har många fördelar, utöver praktisk och snygg förvaring. Eftersom det är en kombinerad enhet blir installationen smidig, då du bara behöver ansluta ett skåp. Välj en exklusiv modell från vårt noga utvalda sortiment och få ett enhetligt kök som enkelt får plats med hela familjens matvaror.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/kylar-frysar.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/Side%20by%20side.webp",
          "order": 1,
          "metaTitle": "Side-by-side kyl/frys - Fri frakt",
          "metaDescription": "Se vårt utbud av side-by-side kyl/frys från välkända varumärken. Vi erbjuder alltid fi frakt från 499 kr. Beställ kyl och frys side-by-side här!",
          "metaHeader": "Kyl- & frys side by side",
          "subCategories": null
        },
        {
          "id": "6717a32174784c6a1aeab251",
          "name": "Kyl/Frys",
          "slug": "kyl-frysskap-kyl-frys",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_256806654_L.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/webimage-DD32E430-CB8F-4933-BF110350AF5E52B8.png",
          "order": 2,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "6717a32976e30404129cff04",
          "name": "Kylskåp",
          "slug": "kyl-frysskap-kylskap",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/vxXr_Hpl.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/_F5I2056.png",
          "order": 3,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "6717a33274784c6a1aeab252",
          "name": "Frysar",
          "slug": "kyl-frysskap-frysar",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_194827642_L.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/PNG-_F5I0398bnew.png",
          "order": 4,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        }
      ]
    },
    {
      "id": "62b48872dbab431cbe6fc341",
      "name": "Spisar",
      "slug": "spisar",
      "description": "En exklusiv spis utgör kökets naturliga samlingsplats där kulinariska mästerverk skapas. Vare sig du föredrar en traditionell spis i gammaldags stil eller en variant med modernt utseende, bidrar en lyxig spis till enklare och mer njutbara matlagningsupplevelser. Här finns ett brett sortiment av exklusiva spisar såväl som enklare varianter. I vårt premiumsegment hittar du allt från <u><a href=\"https://www.gasspisen.se/categories/spisar-gasspisar\">gasspisar</a></u> till <u><a href=\"https://www.gasspisen.se/categories/spisar-induktionsspisar\">induktionsspisar</a></u> från flera ledande varumärken som Smeg, La Germania och Lacanche, med flera.",
      "thumbnailDescription": "",
      "additionalText": "<h2>Stort sortiment av lyxiga spisar</h2>\n<p>Vi har ett stort utbud av lyxiga och exklusiva spisar från marknadens främsta tillverkare. Välj mellan olika modeller i premiumklassen och varierande storlekar, från kompakta 60 cm upp till  generösa 180 cm. En av våra mest populära storlekar är en klassisk <a href=\"https://www.gasspisen.se/categories/spisar-gasspisar-90cm\">gasspis 90 cm</a>, som ger en perfekt arbetsyta för dig som älskar att laga mat. Självklart hjälper vi dig med installationen!</p>\n\n<h2>Moderna spisar i premiumklassen</h2>\n<p>Hos oss finns en spis för varje kök och behov. Hur du än vill att spisen ska passa in i ditt kök hittar du ett exklusivt utbud här, med både <a href=\"https://www.gasspisen.se/categories/gasspis-med-gasugn\">gasspis med gasugn</a> och <a href=\"https://www.gasspisen.se/categories/gasspis-med-elugn\">gasspis med elugn</a>. Vi har många lyxiga spisar i premiumklassen, i både modern stil och i retro utförande, alla med moderna funktioner och bekvämligheter. Det sägs att helheten sitter i detaljerna, och med en exklusiv spis råder det inga undantag. Vårt sortiment består av tidlösa modeller med smarta funktioner kombinerat med en iögonfallande design.</p>",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Alexander_Hoofdbeeld_kopie_1 (1).jpg",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/m90imp-in-set-gloss-black-1024x784.jpg",
      "order": 1,
      "metaTitle": "Lyxiga spisar - Köp unika & exklusiva spisar",
      "metaDescription": "Köp exklusiva spisar i olika stilar. Välj bland flera storlekar och modeller från premiumvarumärken.",
      "metaHeader": "Våra spisar",
      "subCategories": [
        {
          "id": "62b4887cdbab431cbe6fc342",
          "name": "Gasspisar",
          "slug": "spisar-gasspisar",
          "description": "Vi erbjuder Sveriges största sortiment av gasspisar. Välj mellan flera kända kvalitetsmärken, varianter och storlekar för att hitta den rätta modellen för dig. Välkommen till Gasspisen.se för att köpa gasspis! Vi kan även hjälpa dig med installation av din gasspis!",
          "thumbnailDescription": "",
          "additionalText": "<h2>Stort sortiment av gasspisar i Stockholm i vårt showroom</h2>\n<p>I vårt showroom på Sunnanängsvägen 5 i Danderyd i Stockholm hjälper vi dig att välja den modell som passar dig bäst, exempelvis en <a href=\"https://www.gasspisen.se/categories/gasspis-med-gasugn\">gasspis med gasugn</a>. Vi guidar dig till färgval, funktioner och egenskaper så att du kan anpassa spisen efter dina önskemål. Självklart kan du även beställa din spis direkt här på hemsidan, där du till exempel hittar <a href=\"https://www.gasspisen.se/categories/gasspis-med-elugn\">gasspis med elugn</a> i flera varianter och storlekar.</p>\n\n<h2>Gasspisar i olika storlekar</h2>\n<p>Vi förstår att varje kök är unikt och att behoven varierar från hushåll till hushåll. Därför är vi stolta över att erbjuda ett brett sortiment av gasspisar i olika storlekar för att passa alla typer av kök och matlagningsstilar. Nedan hittar du några av våra populära modeller, men vi har även andra storlekar i sortimentet för dig som vill köpa gasspis.</p><br>\n<p>\n- <a href=\"https://www.gasspisen.se/categories/spisar-gasspisar-60cm\">Gasspisar 60 cm</a> är perfekta för mindre kök eller för dig som inte behöver de stora ytorna som större spisar erbjuder. Trots sin kompakta storlek erbjuder de här spisarna effektiva brännare och tillräckligt med utrymme för att laga mångsidiga rätter. <br>\n- <a href=\"https://www.gasspisen.se/categories/spisar-gasspisar-70cm\">Gasspisar 70 cm</a> passar i de flesta moderna kök. De ger mer matlagningsyta än mindre modeller, vilket gör dem lämpliga för bland annat familjer som ofta lagar mat hemma. <br>\n- <a href=\"https://www.gasspisen.se/categories/spisar-gasspisar-90cm\">Gasspisar 90 cm</a> passar den passionerade hemmakocken och erbjuder en professionell nivå av matlagningskapacitet. Dessa större modeller har ofta flera brännare, inklusive högeffektiva brännare för snabb värme och stora ugnar som är idealiska för att laga stora måltider eller flera rätter samtidigt.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/bqt5jfIg55.jpeg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/bqt5jfIg.jpeg",
          "order": 1,
          "metaTitle": "Gasspis Stockholm & online",
          "metaDescription": "Sveriges största sortiment av gasspisar i Stockholm & online. Välj mellan flera kända varumärken, varianter och storlekar. Köp gasspis här!",
          "metaHeader": "Gasspis",
          "subCategories": [
            {
              "id": "63be711fac81a03d9fe71598",
              "name": "60cm",
              "slug": "spisar-gasspisar-60cm",
              "description": "Här hittar du ett brett utbud av gasspisar som är 60 cm breda. Vi erbjuder produkter från flera stora och välkända tillverkare såsom SMEG, IGF och Boretti. Välj mellan flera färger och modeller i vårt sortiment för att hitta en gasspis på 60 cm som faller dig i smaken!",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/varaspisar2.webp",
              "thumbnailUrl": "",
              "order": 2,
              "metaTitle": "Gasspis 60 cm",
              "metaDescription": "Här hittar du ett brett utbud av gasspisar som är 60 cm breda. Vi erbjuder produkter från flera stora och välkända tillverkare. Se utbudet och beställ här!",
              "metaHeader": "Gasspis 60 cm",
              "subCategories": null
            },
            {
              "id": "63be7126ac81a03d9fe71599",
              "name": "70cm",
              "slug": "spisar-gasspisar-70cm",
              "description": "Upptäck vårt sortiment av gasspisar med 70 cm i bredd, där funktionalitet möter enastående design för att förhöja din matlagningsupplevelse. Från Lacanches eleganta franska stil till ILVEs robusta italienska design och SMEGs retrocharm, erbjuder vårt varierade sortiment något för alla smaker och köksstilar. Låt dig inspireras av vårt noggrant utvalda utbud och hitta den perfekta gasspisen på 70 cm, som tar din kulinariska kreativitet till nya höjder!",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/varaspisar2.webp",
              "thumbnailUrl": "",
              "order": 3,
              "metaTitle": "Gasspis 70 cm",
              "metaDescription": "Upptäck vårt sortiment av gasspisar med 70 cm i bredd, där funktionalitet möter enastående design för att förhöja din matlagningsupplevelse. Se utbudet här!",
              "metaHeader": "Gasspis 70 cm",
              "subCategories": null
            },
            {
              "id": "63be712dac81a03d9fe7159a",
              "name": "90cm",
              "slug": "spisar-gasspisar-90cm",
              "description": "Utforska vårt breda sortiment av gasspisar som är 90 cm breda, tillverkade för att möta höga standarder både avseende prestanda och estetik. Vi erbjuder produkter från ledande varumärken såsom Bertazzoni, SMEG och AGA, vilka alla är synonyma med pålitlighet, hållbarhet och avancerad teknik. Se vårt utbud av gasspisar på 90 cm här!",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/bqt5jfIg55.jpeg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/bqt5jfIg.jpeg",
              "order": 4,
              "metaTitle": "Gasspis 90 cm",
              "metaDescription": "Utforska vårt breda sortiment av gasspisar som är 90 cm breda, tillverkade för att möta höga standarder både avseende prestanda och estetik. Beställ här!",
              "metaHeader": "Gasspis 90 cm",
              "subCategories": null
            },
            {
              "id": "659e764110a53f2389e82076",
              "name": "120cm",
              "slug": "spisar-gasspisar-120cm",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/54-1-im-Image_galerie-8477.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/54-1-im-Image_galerie-8477.jpg",
              "order": 6,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "659e767210a53f2389e82077",
              "name": "100cm",
              "slug": "spisar-gasspisar-100cm",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/o8b1057 (1).jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/o8b1057 (1).jpg",
              "order": 5,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "677fa7f56987c20492117541",
              "name": "50cm",
              "slug": "spisar-gasspisar-50cm",
              "description": "",
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/MFBG901ZW2_Img_ImgPrdPho_DetailShot_Pandrager.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/MFBG901ZW2_Img_ImgPrdPho_DetailShot_Pandrager.png",
              "order": 1,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "6a1e808f2b0ec5422f2ecd4d",
              "name": "Gasspis med elugn",
              "slug": "gasspis-med-elugn",
              "description": "En gasspis med elugn ger dig exakt temperaturkontroll med gaslåga, kombinerat med den jämna värmefördelningen från en elektrisk ugn. Vi erbjuder exklusiva modeller från ledande tillverkare som Bertazzoni, Falcon, Ilve, Lacanche, Lofra, Smeg, Steel och La Germania. Hos Gasspisen kan du köpa en smidig gasspis med elugn 50 cm för det lilla köket, en standardmodell på 60 cm, eller en storslagen gasspis med elugn 90 cm (eller större) för det rymliga köket. Välj bland färger som klassiskt rostfritt, djup svart och mjuk beige eller mer iögonfallande kulörer som röd, grön, blå och gul.",
              "thumbnailDescription": null,
              "additionalText": "<h2>Matlagning med trygghet och precision</h2>\n\n<p>Att laga mat ska vara smidigt, och många uppskattar en <a href=\"https://www.gasspisen.se/categories/spisar-gasspisar\">gasspis</a> snabba reaktionstid på hällen kombinerat med ugnens moderna funktioner. Väljer du exempelvis en gasspis med varmluftsugn får du en energieffektiv apparat med generös volym, ofta med dubbla ugnar och dedikerade program för grill, pizza och bakning, där du kan grädda på flera nivåer samtidigt. Vi på Gasspisen har över 50 års erfarenhet av branschen och hjälper dig gärna att jämföra modeller och funktioner, så att du hittar en gasspis med elugn som är bäst i test för dina kulinariska behov.</p>\n",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/ILVEMobil.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/ILVEMobil.png",
              "order": 7,
              "metaTitle": "Gasspis med elugn (50–110 cm) | Köp gasspis med elugn",
              "metaDescription": "Köp gasspis med elektrisk ugn hos oss på Gasspisen.se. Vi erbjuder exklusiva modeller i flera storlekar och färger.",
              "metaHeader": "Gasspis med elugn",
              "subCategories": null
            },
            {
              "id": "6a1e809b2b0ec5422f2ecd4e",
              "name": "Gasspis med gasugn",
              "slug": "gasspis-med-gasugn",
              "description": "En gasspis med gasugn ger en fuktigare värme än en elektrisk ugn, vilket bland annat bevarar saftigheten i kött bättre och ger bröd en härlig skorpa. Vi erbjuder ett noga utvalt sortiment i olika kulörer, material och storlekar från premiumvarumärken som La Germania, Lacanche, Gorenje, Haga och IGF. Välj bland allt från en kompakt gasspis med gasugn på 50 cm till bredare ugnar med generös volym, tillgängliga i stilrena färger som vit, svart och rostfritt stål. Låt dig inspireras och beställ din nya spis redan idag!",
              "thumbnailDescription": null,
              "additionalText": "<h2>Modern driftsäkerhet och genuin känsla</h2>\n<p>Moderna gasugnar är mycket driftsäkra och erbjuder en genuin känsla för den som vill styra värmen i minsta detalj under matlagningen. För att förenkla arbetet i köket är flera modeller utrustade med modern teknik som inre gasgrill, elektrisk tändning och termosäkring. Med över 50 års erfarenhet av branschen har vi djupgående expertis som vi gärna delar med oss av. Hör av dig till oss för personlig rådgivning, eller beställ din nya gasspis med gasugn direkt för en trygg och smidig leverans hem till dörren.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/webimage-A09B8D56-66A1-4152-8801CC1671DD317B.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/o8b11055.jpg",
              "order": 8,
              "metaTitle": "Gasspis med gasugn | Köp gasugnar i olika färger",
              "metaDescription": "Beställ en gasspis med gasugn för en äkta matlagningsupplevelse. Vi har exklusiva gasugnar från 50 cm och uppåt.",
              "metaHeader": "Gasspis med gasugn",
              "subCategories": null
            },
            {
              "id": "6ab501dada5b255d37d62157",
              "name": "Retro Gammaldags",
              "slug": "spisar-gasspisar-retro-gammaldags",
              "description": "En retro spis kombinerar klassiskt formspråk från förra seklet med teknik och funktioner som passar i ett modernt hem. I vårt sortiment finns bland annat <a href=\"https://www.gasspisen.se/categories/spisar-gasspisar\">gasspisar</a> i gammeldags design från ledande tillverkare som Bertazzoni, Ilve, Lofra, Smeg och Steel. Välj mellan standardmått på 60 cm och bredare varianter upp till 120 cm och hitta rätt modell för ditt kök utifrån proportioner, stekyta och ugnsvolym.",
              "thumbnailDescription": null,
              "additionalText": "<h2>Gammeldags spis med tidlös formgivning</h2>\n\n<p>En spis i gammal stil tillför karaktär till kök och hem utan att göra avkall på praktisk matlagningskapacitet. De kännetecknas av mekaniska vred, rejäla handtag och beslag i mässing eller krom, kombinerat med traditionella ugnsfönster och analoga klockor. En genuin gammeldags spis erbjuder massiva komponenter i gjutjärn och emalj i nyanser som crème, antracit och vinrött, kombinerat med traditionell formgivning. För att bevara ytfinishen putsas mässingsdetaljer bäst med metallputs utan slipmedel, medan obehandlade gjutjärnsgaller diskas för hand utan diskmedel och torkas omedelbart för att motverka ytrost.</p>\n\n<h2>Klassisk stil, moderna funktioner</h2>\n\n<p>Under det klassiska skalet på en retro spis gömmer sig teknik anpassad för nutida matlagningsbehov. Många moderna gasspisar har till exempel flamvakt som stänger gastillförseln när lågan slocknar. Beroende på kökets förutsättningar kan du välja gashäll eller induktionshäll med boosterfunktion. Alla våra retro spisar passar för matlagningsentusiaster som söker tidlös köksdesign till sitt hem.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/P15FSNE3_BUG_RN9020SBS_BUG_Set_Det_01(1).jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/P15FSNE3_BUG_RN9020SBS_BUG_Set_Det_01(1).jpg",
              "order": 9,
              "metaTitle": "Retro spis - Köp spis i gammaldags design",
              "metaDescription": "Köp retro spis från Smeg, Ilve, mfl. i slitstarka material med mekaniska vred och mässingsbeslag.",
              "metaHeader": "Retro spis",
              "subCategories": null
            }
          ]
        },
        {
          "id": "62b48898dbab431cbe6fc345",
          "name": "Induktionsspisar",
          "slug": "spisar-induktionsspisar",
          "description": "En induktionsspis ger snabb uppvärmning och exakt temperaturkontroll. Värmen alstras direkt i kokkärlen, vilket sparar tid och energi medan hällen förblir sval. Vi erbjuder induktionsspisar från premiummärken som Lacanche, Bertazzoni och Smeg. Många modeller finns även som <a href=\"https://www.gasspisen.se/categories/spisar-gasspisar\">gasspis</a> för matlagning över öppen låga. Hos oss på Gasspisen kan du tryggt köpa induktionsspis för just ditt kök.",
          "thumbnailDescription": "",
          "additionalText": "<h2>Stort utbud av induktionsspis</h2>\n<p>Hos oss kan du köpa induktionsspis i många olika utföranden, modeller och storlekar. Välj bland eleganta rostfria varianter såväl som stilrena spisar i rött, krom, gult, grönt, blått eller svart och storlekar från 60 cm upp till 120 cm breda.</p>\n<h3>Kompakt och effektiv - 60 cm</h3>\n<p>Om du har ett mindre kök eller behöver en kompakt lösning, kan en <a href=\"https://www.gasspisen.se/categories/spisar-induktionsspisar-60cm\">induktionsspis 60 cm</a> vara det perfekta valet för dig. Trots sin mindre storlek erbjuder den effektiv matlagning och snabb uppvärmning. Vi har många olika färger att välja mellan, så att du kan hitta en modell som passar din övriga inredning.</p>\n<h3>Mer yta för matlagning - 70 cm</h3>\n<p>En <a href=\"https://www.gasspisen.se/categories/spisar-induktionsspisar-70cm \">induktionsspis 70 cm</a> ger dig lite mer utrymme för matlagning, vilket är en fördel i det medelstora köket eller för dig som ofta lagar mat för flera personer. Här får du en fin balans mellan kompakthet och rymd. Modellen erbjuds i flera härliga färger för att matcha din personliga stil.</p>\n<h3>Generös kokyta - 90 cm</h3>\n<p>Har du ett rymligare kök är en <a href=\"https://www.gasspisen.se/categories/spisar-induktionsspisar-90cm\">induktionsspis 90 cm</a> ett populärt val. På den stora kokytan kan du använda flera stora kastruller och pannor samtidigt. Precis som med de andra storlekarna kan du välja från ett brett spektrum av färger för att göra spisen till kökets naturliga blickfång.</p>\n<h3>För det storslagna köket – 100–120 cm</h3>\n<p>För de största köken erbjuder vi <a href=\"https://www.gasspisen.se/categories/spisar-induktionsspisar-100cm\">induktionsspis 100 cm</a> och <a href=\"https://www.gasspisen.se/categories/spisar-induktionsspisar-120cm\">induktionsspis 120 cm</a> . Med dubbla ugnar och gott om plats på induktionshällen kan du enkelt hantera avancerade menyer och storslagna middagsbjudningar.</p>\n<h2>Kontakta oss här!</h2>\n<p>Tveka inte att <a href=\"https://www.gasspisen.se/contact-us \">kontakta oss</a> om du behöver hjälp att hitta rätt modell eller för att få mer information om en produkt i vårt sortiment.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Alexander_Hoofdbeeld_kopie_1.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Alexander_Hoofdbeeld_kopie_1.jpg",
          "order": 2,
          "metaTitle": "Induktionsspisar (60–120 cm) – Köp induktionsspis",
          "metaDescription": "Upptäck vårt breda utbud av induktionsspisar i 60–120 cm. Hos oss kan du tryggt köpa en exklusiv induktionsspis från premiummärken som Smeg och Bertazzoni.",
          "metaHeader": "Induktionsspis",
          "subCategories": [
            {
              "id": "63be7148ac81a03d9fe7159d",
              "name": "60cm",
              "slug": "spisar-induktionsspisar-60cm",
              "description": "Vi har ett brett utbud av induktionsspisar med 60 cm i bredd. Våra utvalda modeller från välkända tillverkare som Ilve, Lofra och Smeg och kombinerar modern teknik med kompakt design och passar det mindre köket. De finns i flera varianter, färger och prisklasser så att du ska kunna hitta en spis som matchar dina förutsättningar. Köp en 60 cm induktionsspis från Gasspisen och upplev modern matlagning i stilrent utförande!",
              "thumbnailDescription": "",
              "additionalText": "<h2>Effektivitet och trygghet i kompakt format</h2>\n<p>En spis med induktion på 60 cm värmer upp kastrullerna blixtsnabbt, samtidigt som själva hällen förblir sval. Många av våra modeller är utrustade med tidsbesparande egenskaper som pyrolytisk självrengöring, så att ugnen blir lekande lätt att hålla ren. En induktionsspis 60 cm erbjuder dessutom rymliga ugnar och smarta funktioner för vardagens alla måltider. \nVi på Gasspisen har över 50 års erfarenhet av spisar och delar gärna med oss av vår expertis inför ditt val. Kontakta oss gärna för personlig rådgivning och beställ din nya premiumspis hos oss, med en trygg och smidig leverans. </p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Boretti-Page_Story_-_What_cooker_to_buy_-_Desktop.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/PROCH94I1ECAT (1)55.jpg",
              "order": 1,
              "metaTitle": "Spis 60 cm induktion – Köp induktionsspis 60 cm",
              "metaDescription": "Köp spis med induktionshäll 60 cm från exklusiva varumärken. Välj mellan olika färger, utföranden och prisklasser. Beställ induktionsspis på 60 cm här!",
              "metaHeader": "",
              "subCategories": null
            },
            {
              "id": "63be714dac81a03d9fe7159e",
              "name": "70cm",
              "slug": "spisar-induktionsspisar-70cm",
              "description": "En induktionsspis 70 cm ger dig extra utrymme för matlagningen utan att dominera hela köket. Vårt sortiment består av noga utvalda spisar från ledande varumärken som Lacanche, Lofra och Steel. Hos Gasspisen kan du beställa en induktionsspis med 70 cm bredd i exklusiva färger, utrustad med funktioner som förenklar vardagen.",
              "thumbnailDescription": "",
              "additionalText": "<h2>En investering för matlagningsglädje</h2>\n<p>Att välja en 70 cm induktionsspis innebär att du får en bredare häll och många modeller har även en rymligare ugn, vilket gör det smidigare att laga mat. Med ett halvt sekels erfarenhet av långsiktig och pålitlig köksutrustning hjälper vi dig</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/induktion-banner.webp",
              "thumbnailUrl": "",
              "order": 2,
              "metaTitle": "Induktionsspis 70 cm bred – Köp en exklusiv spis",
              "metaDescription": "Uppgradera matlagningen med en 70 cm induktionsspis. Våra exklusiva spisar med induktionshäll från välkända märken ger dig utökad arbetsyta i köket.",
              "metaHeader": "Induktionsspis 70 cm",
              "subCategories": null
            },
            {
              "id": "63be7152ac81a03d9fe7159f",
              "name": "90cm",
              "slug": "spisar-induktionsspisar-90cm",
              "description": "För dig som gillar att hålla middagsbjudningar är en induktionsspis 90 cm ett passande val. Den tilltagna hällen ger dig gott om plats att använda stora kastruller och stekpannor samtidigt. Vi erbjuder marknadens mest exklusiva modeller från bland annat Falcon, Smeg och Ilve i olika modeller och prisklasser. När du köper en induktionsspis som är 90 cm bred får du dessutom dubbla ugnar för högsta möjliga flexibilitet.",
              "thumbnailDescription": "",
              "additionalText": "<h2>Skapa ett professionellt kök hemma</h2>\n<p>En induktionsspis 90 cm förvandlar matlagningen från ett tidskrävande måste till ett rent nöje. I vårt breda utbud hittar du handbyggda modeller med eleganta detaljer i mässing, koppar och brons, kombinerat med marknadsledande induktionsteknik. Har du specifika önskemål kring färger eller ugnsfunktioner står våra erfarna experter alltid redo att guida dig till rätt beslut.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/sPs0YELUbaner.jpeg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/sPs0YELU.jpeg",
              "order": 3,
              "metaTitle": "Induktionsspis 90 cm bred – Köp en rymlig spis",
              "metaDescription": "Köp induktionsspis 90 cm hos Gasspisen. Våra exklusiva spisar finns i flera färger och passar dig som vill ha hög prestanda, elegant design & extra arbetsyta.",
              "metaHeader": "Induktionsspis 90 cm",
              "subCategories": null
            },
            {
              "id": "659e888a10a53f2389e8207a",
              "name": "100cm",
              "slug": "spisar-induktionsspisar-100cm",
              "description": "Med en induktionsspis 100 cm får du en imponerande och kraftfull apparat som hanterar de mest krävande menyerna. Vi erbjuder eleganta spisar från kända varumärken som Ilve, Lacanche och Steel. Välj mellan sofistikerade färger som grå, röd, svart, vit eller klassisk rostfri för att skapa ett personligt och storslaget kök med en generös arbetsyta.",
              "thumbnailDescription": null,
              "additionalText": "<h2>Prestanda och design i mästarklass</h2>\n<p>När du investerar i en induktionsspis 100 cm får du i regel flera separata ugnar och en massiv induktionshäll, vilket ger dig friheten att tillaga rätter med helt olika temperaturkrav sida vid sida – för flera personer. Vi på Gasspisen säljer endast utrustning av högsta tänkbara byggkvalitet och hjälper dig att hitta rätt bland alla unika funktioner och tillbehör.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/0W1o7o4U.jpeg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/0W1o7o4U.jpeg",
              "order": 4,
              "metaTitle": "100 cm induktionsspis - Dubbla ugnar & stor häll",
              "metaDescription": "Utforska vårt sortiment av induktionsspis 100 cm från exklusiva varumärken som Lacanche, Steel och Ilve. Köp din spis med trygg leverans hos oss.",
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "659e889110a53f2389e8207b",
              "name": "120cm",
              "slug": "spisar-induktionsspisar-120cm",
              "description": "En induktionsspis 120 cm är den ultimata pjäsen för det enorma köket och den sanna matentusiasten. Här erbjuds du en oöverträffad kapacitet med upp till sju kokzoner och flera inbyggda ugnar i en och samma enhet. Vårt exklusiva sortiment består enbart av handbyggda mästerverk från branschens allra mest respekterade tillverkare, som Ilve. Välj mellan klassiska utföranden i svart, vitt eller rostfritt.",
              "thumbnailDescription": null,
              "additionalText": "<h2>Maximal kapacitet för alla tillfällen</h2>\n<p>En induktionsspis 120 cm levererar blixtsnabb värme och ger dig möjlighet att hantera storslagna middagsbjudningar med total kontroll. En spis i denna imponerande storlek erbjuder även utsökt ingenjörskonst och passionen i tillverkningen lyser igenom i utformningen. Se alla våra modeller och kontakta oss för att skräddarsy en induktionsspis 120 cm som förgyller ditt hem.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Alexander_Hoofdbeeld_kopie_1.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Alexander_Hoofdbeeld_kopie_1.jpg",
              "order": 5,
              "metaTitle": "120 cm induktionsspis – Kompletta & rymliga spisar ",
              "metaDescription": "En induktionsspis 120 cm passar dig som vill ha det absolut bästa. Med enorma hällar och lyxiga funktioner skapar de känslan av ett professionellt kök.",
              "metaHeader": null,
              "subCategories": null
            }
          ]
        },
        {
          "id": "62b488a7dbab431cbe6fc347",
          "name": "Spisar för stadsgas",
          "slug": "spisar-spisar-for-stadsgas",
          "description": "",
          "thumbnailDescription": null,
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Power_Burner_106.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/m90imp-in-set-gloss-black-1024x784.jpg",
          "order": 3,
          "metaTitle": "För stadsgas - Spishäll",
          "metaDescription": "Se vårt sortiment av spishällar för stadsgas. Vi har flera modeller och mängder av varianter från ledande varumärken. Se utbudet här!",
          "metaHeader": null,
          "subCategories": null
        }
      ]
    },
    {
      "id": "62b488b1dbab431cbe6fc348",
      "name": "Spiskåpor",
      "slug": "spiskapor",
      "description": "Vi erbjuder ett brett utbud av spiskåpor, köksfläktar och spisfläktar av hög kvalitet. I sortimentet finns en spiskåpa för alla hem och stilar. Oavsett om du har ett minimalistiskt eller mer traditionellt kök, har vi en spiskåpa för dig. ",
      "thumbnailDescription": "",
      "additionalText": "<h2>Våra köksfläktar</h2>\n<p>Våra köksfläktar finns i flera olika utföranden, gammaldags såväl som mer moderna. Vi har allt från modeller i svart och vitt till rostfritt stål. Köksfläktarna finns även i flera olika storlekar och varianter för att passa alla köksstilar, från det moderna till mer traditionella.</p>\n\n<h2>Spiskåpa i flera modeller - vilken föredrar du?</h2>\n<p>Att välja rätt spiskåpa för köket är inte bara en fråga om funktion, utan också om stil och utrymme. Våra moderna spiskåpor finns i flera olika modeller, designade för att passa olika kökslayouter och stilval.</p>\n\n<h3>Vägghängda</h3>\n<p><a href=\"https://www.gasspisen.se/categories/spiskapor-vagghangd\">Vägghängda köksfläktar</a> är bland de mest traditionella och vanligaste modellerna. De monteras på väggen och finns i en mängd olika stilar och storlekar. Dessa spiskåpor är idealiska för kök där spisen är placerad mot en vägg. De är ofta utrustade med effektiva filter och fläktsystem för att avlägsna matos och ånga.</p>\n\n<h3>Frihängande</h3>\n<p><a href=\"https://www.gasspisen.se/categories/spiskapor-frihangande\">Frihängande köksfläktar</a> är ofta designade för kök med en spis placerad på en köksö. Dessa modeller hänger från taket och är ett centralt blickfång i köket. De erbjuder hög effektivitet och finns i olika designalternativ för att komplettera kökets övergripande estetik.</p>\n\n<h3>Takintegrerade</h3>\n<p><a href=\"https://www.gasspisen.se/categories/spiskapor-takinfalld\">Takintegrerade köksfläktar</a> är inbyggda direkt i taket. Denna modell är perfekt för minimalistiska kök och för de som föredrar en diskret lösning. De är utformade för att vara effektiva samtidigt som de bevarar kökets öppna känsla.</p>\n\n<h3>Inbyggda </h3>\n<p><a href=\"https://www.gasspisen.se/categories/spiskapor-inbyggnadsflakt\">Inbyggda köksfläktar</a> är integrerade direkt i kökets skåp eller arbetsytor. Denna design gör dem nästan osynliga och är ett utmärkt val för de som eftersträvar ett enhetligt köksutseende. Dessa modeller erbjuder också effektiv ventilation och är ofta utrustade med moderna funktioner som tyst drift och energieffektivitet.</p>\n\n<h2>Spisfläkt som lyfter köket</h2>\n<p>Är du ute efter att ge ditt kök ett lyft med en ny spisfläkt? Med en spisfläkt av bra kvalitet höjer du inte bara din matlagningsupplevelse utan ger också köket en förnyad karaktär. Välkommen till Gasspisen!</p>",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/bqt5jfIg.jpeg",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/pmi127s3mk_apm12mk_ov30pmt3mk_set_gen-lr1.jpg",
      "order": 2,
      "metaTitle": "Spiskåpa, Spisfläkt & Köksfläkt",
      "metaDescription": "Brett sortiment av spiskåpor av hög kvalitet - vi har en spiskåpa för varje hem. Välj mellan flera modeller & stilar. Beställ köksfläkt med fri frakt i dag!",
      "metaHeader": "Spiskåpa | Köksfläkt | Spisfläkt",
      "subCategories": [
        {
          "id": "62b48a2ddbab431cbe6fc351",
          "name": "Frihängande",
          "slug": "spiskapor-frihangande",
          "description": "Letar du efter en frihängande köksfläkt eller takhängd köksfläkt har du hittat helt rätt. Vi erbjuder ett brett sortiment av köksfläktar som är frihängande. Oavsett om du söker en takfläkt som är svart, vit eller rostfri har vi det i vårt sortiment. Vi har takhängda köksfläktar för moderna såväl som klassiska kök.",
          "thumbnailDescription": "",
          "additionalText": "<h2>Takmonterad köksfläkt - ett stilrent val</h2>\n<p>En köksfläkt som är takhängd monteras oftast i taket ovanför spisen och ger köket ett modernt utseende. Den kanske största fördelen med en frihängande köksfläkt är att den är väldigt flexibel eftersom den kan placeras fritt i köket, exempelvis ovanför en köksö eller mot en vägg. Oavsett var du vill placera din <a href=\"https://www.gasspisen.se/categories/spiskapor\">köksfläkt</a> eller vilken modell du önskar, är vi övertygade om att vi har den rätta spisfläkten för dig. </p>\n\n<h2>Brett sortiment hos Gasspisen.se</h2>\n<p>Vi erbjuder ett brett sortiment med flera varianter av våra populära köksfläktar som är frihängande. Välj mellan olika modeller, storlekar och färger för att hitta en som faller dig i smaken. I vårt sortiment hittar du även våra omtyckta <a href=\"https://www.gasspisen.se/categories/spiskapor-takinfalld\">takintegrerade köksfläktar</a> som är ett stilsäkert val för dig som vill ha en diskret fläkt i taket som knappt syns.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/ZLMLJ30K.jpeg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/frihangande-koksflakt-prisma-miljobild-2.webp",
          "order": 2,
          "metaTitle": "Frihängande köksfläkt",
          "metaDescription": "Brett sortiment av frihängande köksfläktar. Fri frakt och bra priser! Beställ takmonterad köksfläkt via oss i dag!",
          "metaHeader": "Frihängande köksfläkt",
          "subCategories": null
        },
        {
          "id": "62b48a36dbab431cbe6fc352",
          "name": "Inbyggnadsfläkt",
          "slug": "spiskapor-inbyggnadsflakt",
          "description": "En inbyggd köksfläkt är det perfekta valet för dig som söker en stilren och modern lösning till ditt kök, då denna variant av köksfläkt är inbyggd i skåp eller väggelement. Vi erbjuder ett brett sortiment av inbyggnadsfläktar i flera varianter, modeller och färger.",
          "thumbnailDescription": "",
          "additionalText": "<h2>Inbyggnadsfläkt – diskret och kraftfull</h2>\n<p>En inbyggnadsfläkt är en diskret lösning som ger dig samma kraftfulla effekt som vilken annan <a href=\"https://www.gasspisen.se/categories/spiskapor\">spiskåpa</a> som helst i vårt sortiment. Här hittar du inbyggda köksfläktar från flera erkända varumärken som exempelvis Fjäråskupan.</p>\n\n<h2>En köksfläkt som är inbyggd har många fördelar</h2>\n<p>Inbyggda köksfläktar erbjuder en sömlös design som integreras väl i moderna kök, och bidrar till ett stilrent utseende. Dessa fläktar är effektiva i att avlägsna matos och ånga, vilket bidrar till en fräschare och renare luft i köket. De är ofta tystare och enklare att underhålla än traditionella modeller, med löstagbara filter som kan rengöras i diskmaskin. Dessutom kan en köksfläkt som är inbyggd öka värdet på ditt hem. Ett modernt och välutrustat kök är en attraktiv punkt för många husköpare, och en inbyggd fläkt kan vara en del av detta.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Alexander_Hoofdbeeld_kopie_1.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/XdckY8pX.jpeg",
          "order": 5,
          "metaTitle": "Inbyggd köksfläkt här",
          "metaDescription": "Hitta en inbyggd köksfläkt här. Vi erbjuder ett stort sortiment av inbyggnadsfläktar som integreras snyggt i köket. Beställ i dag med fri frakt!",
          "metaHeader": "Inbyggnadsfläkt",
          "subCategories": null
        },
        {
          "id": "62b48a47dbab431cbe6fc354",
          "name": "Takinfälld",
          "slug": "spiskapor-takinfalld",
          "description": "En takintegrerad köksfläkt kan byggas in och integreras i taket och är ett säkert val för dig som letar efter ett stilsäkert alternativ då fläkten knappt syns. Med en takinfälld köksfläkt ger du köket en modern design och ett stilrent intryck. Här hittar du vårt sortiment av köksfläktar som integreras i taket. ",
          "thumbnailDescription": "",
          "additionalText": "<h2>Köksfläkt i taket - ett stilrent val</h2>\n<p>Allt fler väljer att ha en köksfläkt i taket, då det är ett stilrent alternativ som ger köket ett modernt utseende. Vi erbjuder ett brett sortiment av spisfläktar för tak. Välj mellan flera färger, varianter och modeller för att hitta en köksfläkt som är integrerad och som passar in i just ditt kök.</p><br>\n\n<p>Vårt sortiment inkluderar inte enbart takinfällda köksfläktar, utan även flera andra modeller med allt från frihängande till vägghängda varianter. Inspireras av hela vårt sortiment av <a href=\"https://www.gasspisen.se/categories/spiskapor\">spiskåpor</a>.</p>\n\n<h2>Diskreta och effektiva</h2>\n<p>När du väljer att ha en köksfläkt i taket får du inte bara en modern och läcker lösning som är diskret och knappt syns, du sparar dessutom plats i köket och får en öppnare yta. Tack vare sin höga kapacitet kan dagens moderna takinfällda köksfläktar monteras i taket och ändå fånga upp matoset när du lagar mat.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/detalj_rf_1_miljo.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/detalj_rf_1_miljo.webp",
          "order": 4,
          "metaTitle": "Takintegrerad köksfläkt",
          "metaDescription": "Stort sortiment av takintegrerade köksfläktar som ger ditt kök ett modernt och stilrent utseende. Se våra varianter och beställ köksfläkt till taket här!",
          "metaHeader": "Takintegrerad köksfläkt",
          "subCategories": null
        },
        {
          "id": "62b48a4ddbab431cbe6fc355",
          "name": "Vägghängd",
          "slug": "spiskapor-vagghangd",
          "description": "En vägghängd köksfläkt monteras på väggen över spishällen för att samla upp ånga och matos vid matlagning. Vi erbjuder ett brett sortiment av väggmonterade köksfläktar i flera varianter, färger och från flera kända varumärken. Vi har modeller som passar i moderna såväl som mer klassiska kök.",
          "thumbnailDescription": "",
          "additionalText": "<h2>Stort sortiment av väggmonterade köksfläktar</h2>\n<p>En vägghängd köksfläkt i snygg design som passar in i den övriga köksinredningen kommer att ge hela köket ett lyft. Här hittar du populära modeller från välkända märken såsom Bertazzoni, Smeg och Eico, med flera. Vi erbjuder ett stort sortiment för dig som söker en köksfläkt som är vägghängd. Välj mellan flera modeller och färger med allt från klassiska rostfria, till röda, svarta, vita och krämvita.</p> \n<h3>Fler modeller</h3>\n<p>I vårt sortiment hittar du även fler varianter utöver våra vägghängda modeller. Se hela vårt utbud av <a href=\"https://www.gasspisen.se/categories/spiskapor\">spiskåpor</a> för att hitta det du letar efter.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/bqt5jfIg55.jpeg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/ov91snt3_hcb90fcn_ag120_whg_set_sco_01.jpg",
          "order": 1,
          "metaTitle": "Vägghängd köksfläkt",
          "metaDescription": "Vi erbjuder ett brett sortiment av vägghängda köksfläktar. Välj mellan flera varianter, färger och varumärken. Beställ i dag med fri frakt!",
          "metaHeader": "Vägghängd köksfläkt",
          "subCategories": null
        },
        {
          "id": "62b48a54dbab431cbe6fc356",
          "name": "Tillbehör",
          "slug": "spiskapor-tillbehor",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "",
          "thumbnailUrl": "",
          "order": 7,
          "metaTitle": "Tillbehör - Spiskåpor",
          "metaDescription": "Här hittar du alla möjliga tillbehör till våra spiskåpor. Vi har tillbehör till flera av märkena i vårt sortiment som bland annat Smeg och Ilve.",
          "metaHeader": "Tillbehör - Spiskåpor",
          "subCategories": null
        }
      ]
    },
    {
      "id": "62b48a5ddbab431cbe6fc357",
      "name": "Stadsgas",
      "slug": "stadsgas",
      "description": "Här hittar du våra produkter som passar för stadsgas i Stockholm, Göteborg och Malmö. Vi har ett brett sortiment med bland annat gasspisar och glashällar från olika varumärken och i flera modeller. ",
      "thumbnailDescription": "",
      "additionalText": "<div>                 <h2>STADSGAS - KOMPATIBLA PRODUKTER</h2>                 <p>I vårt sortiment av produkter kompatibla med stadsgas hittar du både gasspisar och gashällar. Samtliga svenska nät för stadsgas matas i dag med biogas eller naturgas i en blandning med luft. För att gasen ska kunna upptäckas med luktsinnet innehåller stadsgas också ett speciellt luktämne. </p><br>\n<h2>BRETT UTBUD AV PRODUKTER</h2>\n<p>Ovan ser du hela vårt utbud av produkter som är kompatibla med den stadsgas som finns i samtliga svenska stadsgasnät. Vårt sortiment inkluderar bland annat både gasspisar och gashällar i flera storlekar och modeller. Vi hjälper dig hela vägen från rådgivning kring våra produkter till installation. Se våra produkter för <a href=\"https://www.gasspisen.se/categories/stadsgas-stockholm\">stadsgas i Stockholm</a>, <a href=\"https://www.gasspisen.se/categories/stadsgas-goteborg\">stadsgas i Göteborg</a> och <a href=\"https://www.gasspisen.se/categories/stadsgas-malmo\">stadsgas i Malmö</a>.</p> </div>",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Power_Burner_106.jpg",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/m90imp-in-set-gloss-black-1024x784.jpg",
      "order": 6,
      "metaTitle": "Stadsgas - Kompatibla produkter",
      "metaDescription": "Brett sortiment av kompatibla produkter för stadsgas i Stockholm, Göteborg och Malmö. Se hela utbudet här!",
      "metaHeader": "Stadsgas",
      "subCategories": [
        {
          "id": "62b48a69dbab431cbe6fc358",
          "name": "Göteborg",
          "slug": "stadsgas-goteborg",
          "description": "Här hittar du våra produkter som passar för stadsgas i Göteborg. Sortimentet inkluderar allt från gashällar och induktionshällar till gasspisar i flera storlekar och varianter.",
          "thumbnailDescription": "",
          "additionalText": "<h2>MÅNGA VALMÖJLIGHETER FÖR GÖTEBORGS STADSGAS</h2>\n<p>Oavsett om du söker en induktionshäll, gashäll eller gasspis som passar för stadsgas i Göteborg har vi vad du söker. Välj mellan våra produkter i flera storlekar, färger och varianter från flera av landets ledande tillverkare.</p>\n<br><h3>HÖGKVALITATIVA PRODUKTER</h3>\n<p>Med ett brett utbud av högkvalitativa gasspisar, hällar och tillbehör kan vi erbjuda den perfekta modellen för ditt kök. Utforska vårt sortiment och hitta en produkt som passar dina behov och stil. Med snabb leverans och utmärkt kundservice är vi ett smart val när du ska köpa produkter för stadsgas. </p><br>\n<p>Vårt sortiment inkluderar även produkter för <a href=\"https://www.gasspisen.se/categories/stadsgas-stockholm\">stadsgas i Stockholm</a> och <a href=\"https://www.gasspisen.se/categories/stadsgas-malmo\">stadsgas i Malmö</a>! Tveka inte att kontakta oss för mer information om en produkt eller personlig service.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/gasspis_elugn_banner_1.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/Go%CC%88teborg.webp",
          "order": 2,
          "metaTitle": "Stadsgas Göteborg",
          "metaDescription": "Här hittar du våra produkter som passar för stadsgas i Göteborg. Sortimentet inkluderar allt från gashällar och induktionshällar till gasspisar.",
          "metaHeader": "Stadsgas Göteborg",
          "subCategories": null
        },
        {
          "id": "62b48a71dbab431cbe6fc359",
          "name": "Malmö",
          "slug": "stadsgas-malmo",
          "description": "Vi har ett stort sortiment av produkter som passar för stadsgas i Malmö. Här har vi samlat dessa produkter – gasspisar såväl som gashällar och induktionshällar i flera varianter, färger och storlekar.",
          "thumbnailDescription": "",
          "additionalText": "<h2>FLERA VARIANTER FÖR MALMÖS STADSGAS</h2>\n<p>Här hittar du produkter för Malmös stadsgas. Vårt sortiment inkluderar bland annat gasspisar samt gas- och induktionshällar i flera olika varianter, färger och storlekar. Vi erbjuder dessutom produkter från flera av marknadens ledande varumärken.</p><br>\n<h3>KVALITETSPRODUKTER</h3>\n<p>Om du letar efter produkter för stadsgas i Malmö kan vi erbjuda ett brett sortiment för dig. Vårt utbud inkluderar både gasspisar, hällar och tillbehör av högsta kvalitet. Kolla igenom vårt sortiment för att hitta den perfekta produkten för dig och ditt kök. Vi erbjuder även produkter för <a href=\"https://www.gasspisen.se/categories/stadsgas-stockholm\">stadsgas i Stockholm</a> och <a href=\"https://www.gasspisen.se/categories/stadsgas-goteborg\">stadsgas i Göteborg</a>.</p>\n",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/banner_a.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/Malmo%CC%88.webp",
          "order": 3,
          "metaTitle": "Stadsgas Malmö",
          "metaDescription": "Vi erbjuder ett brett sortiment av produkter som passar för stadsgas i Malmö med både gasspisar och gashällar, m.m. Se utbudet och beställ här!",
          "metaHeader": "Stadsgas Malmö",
          "subCategories": null
        },
        {
          "id": "62b48a77dbab431cbe6fc35a",
          "name": "Stockholm",
          "slug": "stadsgas-stockholm",
          "description": "Här har vi samlat alla produkter som passar för stadsgas i Stockholm. Vi har ett brett sortiment av gas- och induktionshällar samt gasspisar i flera modeller och storlekar, allt från 60 cm till 120 cm.",
          "thumbnailDescription": "",
          "additionalText": "<h2>STORT SORTIMENT FÖR STOCKHOLMS STADSGAS</h2>\n<p>Vi har ett stort utbud av produkter som passar för Stockholms stadsgas. I vårt sortiment hittar du såväl gasspisar som induktions- och gashällar. Självklart erbjuder vi även produkter från flera olika tillverkare. I sortimentet finns bland annat produkter från Smeg, Bertazzoni och La Germania, med flera.</p><br>\n<p>Vi erbjuder även produkter för <a href=\"https://www.gasspisen.se/categories/stadsgas-goteborg\">stadgas i Göteborg</a> och <a href=\"https://www.gasspisen.se/categories/stadsgas-malmo\">stadsgas i Malmö</a> och hjälper dig med installation!</p>\n<br><h3>HITTA DEN PERFEKTA MODELLEN FÖR DITT KÖK</h3>\n<p>Med ett brett utbud av högkvalitativa produkter kan du känna dig trygg med oss som leverantör. Bläddra igenom vårt sortiment för att hitta den perfekta modellen för ditt kök och som passar både din stil och dina behov. Tveka inte att kontakta oss om du vill ha mer information om våra produkter eller hur vi kan hjälpa dig!</p>\n",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/varaspisar2.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/categories/Stockholm.webp",
          "order": 1,
          "metaTitle": "Stadsgas Stockholm - Gasspisar & Gashällar",
          "metaDescription": "Här hittar du våra produkter som passar för stadsgas i Stockholm. Allt från gas- och induktionshällar till gasspisar i olika modeller. Se utbudet här!",
          "metaHeader": "Stadsgas Stockholm",
          "subCategories": null
        }
      ]
    },
    {
      "id": "6717a1c4a4efcf6e663bbfd7",
      "name": "Till köket",
      "slug": "till-koket",
      "description": null,
      "thumbnailDescription": null,
      "additionalText": null,
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_146875581_L.jpg",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_692745074_S.jpg",
      "order": 7,
      "metaTitle": null,
      "metaDescription": null,
      "metaHeader": null,
      "subCategories": [
        {
          "id": "6717a1cefb2ae549d2aea8ca",
          "name": "Köksredskap",
          "slug": "till-koket-koksredskap",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_192740638_XL.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/28405_env_1_2302_high.jpg",
          "order": 1,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": [
            {
              "id": "6717a1eca4efcf6e663bbfd8",
              "name": "Kryddkvarnar",
              "slug": "till-koket-koksredskap-kryddkvarnar",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_168776780_L.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_101912336_S.jpg",
              "order": 2,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "6717a1f3fb2ae549d2aea8cb",
              "name": "Redskap",
              "slug": "till-koket-koksredskap-redskap",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_182945156_L.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_558135570_S.jpg",
              "order": 3,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "6717a1f974784c6a1aeab24b",
              "name": "Rivjärn",
              "slug": "till-koket-koksredskap-rivjarn",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_505539388_L.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_211911150_S.jpg",
              "order": 4,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "6717a202f360dd6a45671dc2",
              "name": "Formar",
              "slug": "till-koket-koksredskap-formar",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_365765640_L.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/26620_env_1_high.jpg",
              "order": 1,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "6717a20a76e30404129cfefd",
              "name": "Övriga köksredskap",
              "slug": "till-koket-koksredskap-ovriga-koksredskap",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_176757524_L.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_56528105_S.jpg",
              "order": 5,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            }
          ]
        },
        {
          "id": "6717a1d474784c6a1aeab24a",
          "name": "Kokkärl och stekpannor",
          "slug": "till-koket-kokkarl-och-stekpannor",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_207282058_L.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_317163876_S.jpg",
          "order": 2,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": [
            {
              "id": "6717a214a4efcf6e663bbfd9",
              "name": "Stekpannor",
              "slug": "till-koket-kokkarl-och-stekpannor-stekpannor",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_75627603_L.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_104361990_S.jpg",
              "order": 3,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "6717a21bfb2ae549d2aea8cc",
              "name": "Traktörpannor",
              "slug": "till-koket-kokkarl-och-stekpannor-traktorpannor",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_72978063_L.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_226249132_S.jpg",
              "order": 4,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "6717a227f360dd6a45671dc3",
              "name": "Kastrull",
              "slug": "till-koket-kokkarl-och-stekpannor-kastrull",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_475492172_L.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_428389506_S.jpg",
              "order": 2,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "6717a22c76e30404129cfefe",
              "name": "Grytor",
              "slug": "till-koket-kokkarl-och-stekpannor-grytor",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_515251592_L.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_514386306_S.jpg",
              "order": 1,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            }
          ]
        },
        {
          "id": "6717a1dcf360dd6a45671dc1",
          "name": "Baktillbehör",
          "slug": "till-koket-baktillbehor",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_166415386_XL.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_163626904_S.jpg",
          "order": 3,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": [
            {
              "id": "6717a24174784c6a1aeab24d",
              "name": "Bakformar",
              "slug": "till-koket-baktillbehor-bakformar",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_200964210_L.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_7210960_S.jpg",
              "order": 1,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "6717a24d76e30404129cfeff",
              "name": "Övriga baktillbehör",
              "slug": "till-koket-baktillbehor-ovriga-baktillbehor",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_100579324_L.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_72472683_S.jpg",
              "order": 3,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "6717a28474784c6a1aeab250",
              "name": "Mäta och Väga",
              "slug": "till-koket-baktillbehor-mata-och-vaga",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_643732188_L.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_528993084_S.jpg",
              "order": 2,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            }
          ]
        },
        {
          "id": "6717a1e176e30404129cfefc",
          "name": "Knivar",
          "slug": "till-koket-knivar",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_325441376_L.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_62090021_S.jpg",
          "order": 4,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": [
            {
              "id": "6717a25b76e30404129cff00",
              "name": "Brödknivar",
              "slug": "till-koket-knivar-brodknivar",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_4328336_L.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_197585742_S.jpg",
              "order": 1,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "6717a26174784c6a1aeab24e",
              "name": "Knivsett",
              "slug": "till-koket-knivar-knivsett",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_69955981_L.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_272177224_S.jpg",
              "order": 3,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "6717a26776e30404129cff01",
              "name": "Knivslipar",
              "slug": "till-koket-knivar-knivslipar",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_34545391_L.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_26182759_S.jpg",
              "order": 4,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "6717a27376e30404129cff02",
              "name": "Övriga knivar",
              "slug": "till-koket-knivar-ovriga-knivar",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_5049174_L.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_109477138_S.jpg",
              "order": 5,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "6717a29176e30404129cff03",
              "name": "Kockknivar",
              "slug": "till-koket-knivar-kockknivar",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_123627444_L.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_214786546_S.jpg",
              "order": 2,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            }
          ]
        }
      ]
    },
    {
      "id": "67ed04a0f87ed1538403999b",
      "name": "Utematlagning",
      "slug": "utematlagning",
      "description": "Skapa den perfekta utomhusupplevelsen med vårt sortiment för utematlagning! Här hittar du kvalitetsgrillar och smarta grilltillbehör som tar din matlagning till nästa nivå. Oavsett om du är en passionerad grillmästare eller njuter av enklare måltider utomhus har vi allt du behöver.",
      "thumbnailDescription": null,
      "additionalText": null,
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Banner utematlagning.png",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_307119006_S.jpg",
      "order": 8,
      "metaTitle": null,
      "metaDescription": null,
      "metaHeader": null,
      "subCategories": [
        {
          "id": "67ed04a45f34885e9ef33db9",
          "name": "Grillar",
          "slug": "utematlagning-grillar",
          "description": "Upptäck vårt sortiment av premiumgrillar för alla tillfällen! Oavsett om du föredrar gasol, kol eller hybridlösningar har vi grillen som passar din uteplats. Våra modeller kombinerar stilren design med hög prestanda för en optimal grillupplevelse.",
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Banner grill.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_403207974_XL.jpg",
          "order": 1,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": [
            {
              "id": "67f4e28078abf523e02c71f9",
              "name": "Gasolgrill",
              "slug": "utematlagning-grillar-gasolgrill",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Banner gasolgrill.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Regal-Q-590-IR_5.jpg",
              "order": 1,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "67f4e28a78abf523e02c71fa",
              "name": "Kolgrill",
              "slug": "utematlagning-grillar-kolgrill",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_162918850_XL.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_81584008_XL.jpg",
              "order": 2,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "6847fc0959dfb4231e7c6d19",
              "name": "Pelletsgrill",
              "slug": "utematlagning-grillar-pelletsgrill",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/BK_RegalPellet500_Lifestyle_01.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/BK_RegalPellet500_Lifestyle_02.jpg",
              "order": 3,
              "metaTitle": "Pelletsgrillar för exakt temperatur och rökig grillsmak | [Ditt företagsnamn]",
              "metaDescription": "Upptäck våra pelletsgrillar – perfekt för dig som vill ha rökig BBQ-smak med modern teknik och exakt temperaturkontroll. Långsam grillning har aldrig varit enklare.",
              "metaHeader": "Pelletsgrillar för smakrik BBQ och enkel temperaturstyrning",
              "subCategories": null
            }
          ]
        },
        {
          "id": "67ed04aa5397240f6e9aeddb",
          "name": "Tillbehör",
          "slug": "utematlagning-tillbehor",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_563558678_L.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_36810279_S.jpg",
          "order": 4,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": [
            {
              "id": "67f4edc978abf523e02c71fd",
              "name": "Tillagning",
              "slug": "utematlagning-tillbehor-tillagning",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_170017246_XL.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/pink-3-600x600.jpg",
              "order": 1,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "67f4edd078abf523e02c71fe",
              "name": "Överdrag",
              "slug": "utematlagning-tillbehor-overdrag",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Cover-1-2048x476.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/accessory_68490-8.jpg",
              "order": 2,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            }
          ]
        },
        {
          "id": "67f4defb78abf523e02c71f8",
          "name": "Grillkol och Briketter",
          "slug": "utematlagning-grillkol-och-briketter",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_245067786_XL.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/Depositphotos_81584008_XL.jpg",
          "order": 3,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "6847fef3a3445f223b609166",
          "name": "Rökar",
          "slug": "utematlagning-rokar",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/BK_SmokeOffset XL_Life_02.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/BK_SmokeOffset XL_Life_05.jpg",
          "order": 2,
          "metaTitle": "Rökar & offset-smokers från Broil King | Äkta BBQ-smak hemma",
          "metaDescription": "Grilla som proffsen med en offset-smoker! Våra rökar från Broil King ger dig klassisk lågtemperaturgrillning och djup rökighet – perfekt för brisket, ribs och pulled pork.",
          "metaHeader": "Rökar för äkta BBQ – offset-smokers från Broil King",
          "subCategories": null
        }
      ]
    }
  ],
  "storeType": "B2C",
  "storeDeliveries": [
    {
      "id": "62f22d70a92edf5ce162d3af",
      "name": "Delivery 1",
      "label": "1-3 dagar",
      "buyable": true
    },
    {
      "id": "62f22d85a92edf5ce162d3b0",
      "name": "Delivery 2",
      "label": "3-5 dagar",
      "buyable": true
    },
    {
      "id": "62f22d91a92edf5ce162d3b1",
      "name": "Delivery 3",
      "label": "5-8 dagar",
      "buyable": true
    },
    {
      "id": "62f22d9fa92edf5ce162d3b2",
      "name": "Delivery 4",
      "label": "1-2 veckor",
      "buyable": true
    },
    {
      "id": "62f22dada92edf5ce162d3b3",
      "name": "Delivery 5",
      "label": "2-4 veckor",
      "buyable": true
    },
    {
      "id": "62f22dbba92edf5ce162d3b4",
      "name": "Delivery 6",
      "label": "4-6 veckor",
      "buyable": true
    },
    {
      "id": "62f22dc8a92edf5ce162d3b5",
      "name": "Delivery 7",
      "label": "6-8 veckor",
      "buyable": true
    },
    {
      "id": "62f22dd3a92edf5ce162d3b6",
      "name": "Delivery 8",
      "label": "8-10 veckor",
      "buyable": true
    },
    {
      "id": "62f22de0a92edf5ce162d3b7",
      "name": "Delivery 9",
      "label": "Obestämd tid",
      "buyable": true
    },
    {
      "id": "62f22deca92edf5ce162d3b8",
      "name": "Delivery 10",
      "label": "Ej i lager",
      "buyable": false
    },
    {
      "id": "63331c31a4f7cb461c06021e",
      "name": "Delivery 11",
      "label": "4-6 månader",
      "buyable": true
    },
    {
      "id": "63401e14b9dc3fbeb3d05009",
      "name": "Delivery 12",
      "label": "6-8 månader",
      "buyable": true
    }
  ],
  "language": "sv",
  "currency": "SEK",
  "labels": {
    "currency": "SEK",
    "priceCurrency": "SEK"
  },
  "paths": {
    "brandsUrlPath": "/varumarken",
    "categoriesUrlPath": "/categories",
    "tagsUrlPath": "/t",
    "productsUrlPath": "/p",
    "blogsUrlPath": "/blog"
  },
  "staticLinks": [
    {
      "id": "brands",
      "label": "Varumärken",
      "path": "/varumarken"
    },
    {
      "id": "blog",
      "label": "Blogg",
      "path": "/blog"
    },
    {
      "id": "minasidor",
      "label": "",
      "path": "/account"
    }
  ],
  "logoUrl": "https://storage.googleapis.com/gecko-media/EC_1034/tags/gasspisen-logo-dark.png",
  "showCart": true,
  "sortingOptions": [
    {
      "sortBy": "price",
      "sortOrder": "DESC",
      "sortLabel": "Pris högt-lågt",
      "default": true
    },
    {
      "sortBy": "price",
      "sortOrder": "ASC",
      "sortLabel": "Pris lågt-högt",
      "default": false
    },
    {
      "sortBy": "created",
      "sortOrder": "DESC",
      "sortLabel": "Nyaste",
      "default": false
    }
  ],
  "desktopItemHeight": "20vw",
  "mobileItemHeight": "45vw",
  "maxContentWidth": 1270,
  "menuMaxContentWidth": 1270,
  "sliderDefaultValues": [
    0,
    300000
  ],
  "freeShippingOver": 999,
  "shippingProviderConfig": {
    "provider": "DEFAULT",
    "simpleShipping": {
      "minimumOrderAmountForFreeDelivery": 999,
      "deliveryFee": 139
    }
  },
  "paymentProviderConfig": {
    "providerName": "KLARNA",
    "providerOptions": {
      "klarna": {
        "purchaseCountry": "SE",
        "availableCountries": null,
        "purchaseCurrency": "SEK",
        "phoneMandatory": true,
        "colorButton": null,
        "termsUrl": "/kopvillkor",
        "cancellationTermsUrl": "/kopvillkor#angerratt"
      }
    }
  },
  "filtersBeforeShowMore": 3,
  "sliderMaxPrice": 300000,
  "topNavHeight": {
    "panel": {
      "base": 0,
      "sm": "5vh"
    },
    "content": {
      "base": "8vh",
      "sm": "14vh"
    },
    "spacer": {
      "base": "8vh",
      "sm": "19vh"
    },
    "hero": {
      "base": "92vh",
      "sm": "81vh",
      "md": "60vh"
    }
  },
  "topNavSlideOutFeaturedCategories": 3,
  "socialMediaItems": [
    {
      "label": "Facebook",
      "icon": "FACEBOOK",
      "href": "https://www.facebook.com/gasspisen/?view_public_for=104695747628337"
    },
    {
      "label": "Instagram",
      "icon": "INSTAGRAM",
      "href": "https://www.instagram.com/gasspisen/?hl=sv"
    }
  ],
  "topNavPanel": {
    "items": [
      {
        "icon": "FaCrown",
        "label": "Om oss",
        "href": "/om-oss"
      },
      {
        "icon": "MdOutlineLocalShipping",
        "label": "Fri frakt över 999 kr"
      },
      {
        "icon": "FaCrown",
        "label": "Över 25 år erfarenhet"
      }
    ]
  }
};
export const serverTheme = {
  "colors": {
    "primary": "#FFAB58",
    "secondary": "#FFAB58",
    "klarna": "#FFB366",
    "customColorScheme": {
      "50": "#FFF2E6",
      "100": "#FFE6CC",
      "200": "#FFD9B3",
      "300": "#FFCC99",
      "400": "#FFBF80",
      "500": "#FFB366",
      "600": "#FFAB58",
      "700": "#FF9933",
      "800": "#B35900",
      "900": "#804000"
    },
    "background": {
      "default": "#FFFFFF",
      "surface": "#F4F4F4",
      "mildDark": "rgb(1,50,75)",
      "dark": "rgb(0,25,38)",
      "darkest": "rgb(0,19,28)",
      "translucent": "rgba(244,244,244,0.90)",
      "overlayHalf": "rgba(0,0,0,0.25)",
      "overlay": "rgba(0,0,0,0.5)",
      "primary": "rgba(146,176,156,0.1)",
      "secondary": "rgba(205,15,50,0.1)"
    },
    "text": {
      "default": "#212626",
      "disabled": "#9DB1BC",
      "mild": "#5A7A84",
      "light": "#FFFFFF",
      "darkGrey": "#323A3A",
      "colored": "#315D91"
    },
    "status": {
      "success": "rgba(29,195,149,1)",
      "warning": "#EED892",
      "warning2": "#F5E6D6",
      "error": "#F35F5F"
    },
    "brand": {
      "10": "#EAEBEF",
      "50": "#D4DDE3",
      "100": "#C2CED6",
      "200": "#AFC0C9",
      "300": "#9DB1BC",
      "400": "#7B95A0",
      "500": "#5A7A84",
      "600": "#4B6D76",
      "700": "#3C6068",
      "800": "#1F464C",
      "900": "#0A2D31",
      "1000": "#323A3A",
      "1100": "#212626",
      "darkExtraLight": "rgba(0,25,38,0.20)",
      "darkGrey": "#222222"
    }
  }
}; 
